import { KeyCode } from '../../../../core/utils/src/dom';
var isSpecialCommand = function (event) {
    var keyCode = event.keyCode;
    return keyCode > 7 && keyCode < 47 && keyCode !== KeyCode.space;
};
var isClipboardCommand = function (event) { return event.ctrlKey || event.metaKey; };
export var isCommand = function (event) { return isSpecialCommand(event) || isClipboardCommand(event); };
export var isDigit = function (key) { return !isNaN(parseInt(key, 10)); };
//# sourceMappingURL=keys.js.map